export function downloadBusContract(id) {
    return axios({
        url: `/api/test/insurance/bus/contract/take`,
        method: 'post',
        data: {
            contractId: id,
        },
    });
}
